import React from "react";
import { navigate, RouteComponentProps } from "@reach/router";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import { Flex, Box, Button, H1, H2, Text } from "@atoms";
import { useStoreAppValue } from "@hooks";
import { RailsUrl, analytics } from "@services";
import { BrandShowcase, OnboardingContainer } from "../components";
import { OnboardingIntroQuery } from "./__generated__/OnboardingIntroQuery";

// == Types ================================================================

// == Constants ============================================================

const ONBOARDING_QUERY = gql`
  query OnboardingIntroQuery {
    Viewer {
      id
      onboarding {
        questions {
          id
        }
      }
    }
    Campaign {
      id
      name
      isViewerOwner
      goal {
        formatted
      }
    }
  }
`;

// == Component ============================================================

export function OnboardingIntro(_props: RouteComponentProps) {
  const { data, loading, error } = useQuery<OnboardingIntroQuery>(ONBOARDING_QUERY);
  const { campaignId, isOwner } = useStoreAppValue();

  const onSubmitClick = () => {
    analytics.track.onboardingStart({ campaignId }, isOwner);
    navigate(RailsUrl.onboardingQuestionUrl(questions?.[0].id));
  };

  const questions = data?.Viewer.onboarding?.questions;
  return (
    <OnboardingContainer
      hasError={!!error || !questions || questions.length === 0}
      loading={loading}
    >
      <Flex alignItems="center" flexDirection="column" justifyContent="center">
        {/* ===Header begins=== */}
        <Box pt={3} px={5} textAlign="center">
          {data?.Campaign?.isViewerOwner ? (
            <>
              <H1>How Much Can I Earn?</H1>
              <Text fontSize="1">
                Answer 5 questions to calculate how much cash you can earn back.
              </Text>
            </>
          ) : (
            <>
              <H1 mb={1}>{data?.Campaign?.name}</H1>
              <H2 color="primary" mb={2}>
                {data?.Campaign?.goal?.formatted} Goal
              </H2>
              <Text fontSize="1">
                Personalize your store and estimate how much cashback you can earn.
              </Text>
            </>
          )}
        </Box>
        {/* ===Header ends=== */}
        {/* ===Brand Showcase begins=== */}
        <Box pb={3} pt={5}>
          <BrandShowcase />
        </Box>

        {/* ===Brand Showcase ends=== */}
        {/* ===Button begins=== */}
        <Button borderRadius="none" width="100%" onClick={onSubmitClick}>
          Calculate My Cashback
        </Button>
        {/* ===Button ends=== */}
      </Flex>
    </OnboardingContainer>
  );
}

// == Styles ===============================================================
